import React from 'react';
import './doc-restore-veil.css';

/** Full-scrollport cover while a saved scroll offset is applied. */
export const DocScrollHost = ({ className, holdCover, children }) => (
  <div className={`${className}${holdCover ? ' is-restoring' : ''}`}>
    {children}
    {holdCover ? <DocRestoreVeil /> : null}
  </div>
);

const DocRestoreVeil = () => (
  <div className="doc-restore-veil" role="status" aria-live="polite">
    <span className="doc-restore-veil__label">Loading document…</span>
  </div>
);

export default DocRestoreVeil;
